import styled from 'styled-components'

const FooterButtonsWrapper = styled.div`
  display: flex;
  width: 100%;
  gap: 12px;

  button {
    display: block;
    width: calc(50% - 6px);
  }
`

export const s = { FooterButtonsWrapper }
